import { Card, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@mui/material';
import { stateFields } from 'src/models/state';
import { countryFields } from 'src/models/country';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import TableSortLabel from '@mui/material/TableSortLabel';
import { useState } from 'react';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });

  return stabilizedThis.map((el) => el[0]);
}

const StateList = ({
  states,
  page,
  pagesize,
  handleOnPageChange,
  handleLimitChange,
  totalState,
  removeState,
  open,
  onOpenModal,
  idState,
  setIdState,
  onOpenModalState,
  setValue
}) => {
  const { t } = useTranslation();
  const [oderDirection, setOrderDirection] = useState('asc');
  const [valueToOderBy, setValueToOderBy] = useState(countryFields.name.label);

  const handleRequestSort = (event, property) => {
    const isAscending = valueToOderBy === property && oderDirection === 'asc';
    setValueToOderBy(property);
    setOrderDirection(isAscending ? 'desc' : 'asc');
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };

  return (
    <Card>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={valueToOderBy === countryFields.name.name}
                direction={valueToOderBy === countryFields.name.name ? oderDirection : 'asc'}
                onClick={createSortHandler(countryFields.name.name)}
              >
                {countryFields.name.label}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={valueToOderBy === countryFields.code.name}
                direction={valueToOderBy === countryFields.code.name ? oderDirection : 'asc'}
                onClick={createSortHandler(countryFields.code.name)}
              >
                {countryFields.code.label}
              </TableSortLabel>
            </TableCell>{' '}
            <TableCell>
              <TableSortLabel
                active={valueToOderBy === stateFields.name.name}
                direction={valueToOderBy === stateFields.name.name ? oderDirection : 'asc'}
                onClick={createSortHandler(stateFields.name.name)}
              >
                {stateFields.name.label}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={valueToOderBy === stateFields.code.name}
                direction={valueToOderBy === stateFields.code.name ? oderDirection : 'asc'}
                onClick={createSortHandler(stateFields.code.name)}
              >
                {stateFields.code.label}
              </TableSortLabel>
            </TableCell>
            <TableCell>{stateFields.action.label}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {states &&
            stableSort(states, getComparator(oderDirection, valueToOderBy)).map((state) => (
              <TableRow key={state._id}>
                <TableCell>{state.country.name}</TableCell>
                <TableCell>{state.country.code}</TableCell>
                <TableCell>{state.name}</TableCell>
                <TableCell>{state.code}</TableCell>
                <TableCell>
                  <Tooltip title="Edit">
                    <IconButton
                      size="small"
                      aria-label="edit"
                      onClick={() => {
                        onOpenModalState(true);
                        setIdState(state._id);
                        setValue('name', state.name);
                        setValue('code', state.code);
                        setValue('country', state.country._id);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      size="small"
                      aria-label="delete"
                      onClick={() => {
                        onOpenModal(true);
                        setIdState(state._id);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={totalState}
        onPageChange={handleOnPageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={pagesize}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
      />
      <Dialog open={open} onClose={() => onOpenModal(false)}>
        <DialogTitle>{t('dialog.title')}</DialogTitle>
        <DialogActions>
          <Button onClick={() => onOpenModal(false)}> {t('dialog.noButton')}</Button>
          <Button
            onClick={() => {
              removeState(idState);
              onOpenModal(false);
            }}
            autoFocus
          >
            {t('dialog.yesButton')}
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};
StateList.propTypes = {
  states: PropTypes.array,
  page: PropTypes.number,
  pagesize: PropTypes.number,
  totalState: PropTypes.number,
  open: PropTypes.bool,
  onOpenModal: PropTypes.func,
  onOpenModalState: PropTypes.func,
  idState: PropTypes.string,
  setIdState: PropTypes.func,
  removeState: PropTypes.func,
  handleOnPageChange: PropTypes.func,
  setValue: PropTypes.func,
  handleLimitChange: PropTypes.func
};
export default StateList;
